import {
	SET_CUSTOMERS,
	CLEAR_CUSTOMERS,
	SET_ERROR_LOGS,
	UPDATE_CUSTOMER,
	UPDATE_CUSTOMERS_ZONE,
	TOAST_MESSAGES_PUSH,
	ADD_CUSTOMERS_COMPANIES_LOCATIONS,
	CUSTOMERS_COMPANIES_LOCATIONS,
	SET_CUSTOMERS_AUTOSUGGESTIONS,
	CLEAR_CUSTOMERS_AUTOSUGGESTIONS,
	UPDATE_ACCORDION_STATUSES,
	CLEAR_ACCORDION_STATUSES,
	SET_ZONE_HISTORY_LOGS
} from './mutation-types';

import { ApiService as api } from '@/services/axiosHelper';
import { mergePayloadObjects } from '@/utils/object';
import _ from 'lodash';

let messageObj = {
	statusCode: 400,
	message: 'An error occurred. Please try again.'
};

const generateKey = params => {
	return `CCL_type:${params.searchType}_search:${params.search}_customerId:${params.customerId}_comapnyId:${params.companyId}_locationsId:${params.locationId}_sortBy:${params.sortBy}_sortDirection:${params.sortDirection}_page:${params.page}_count:${params.count}_stateId:${params.stateId}`;
};
export default {
	strict: process.env.NODE_ENV !== 'production',
	name: 'customers',
	namespaced: true,
	state: {
		customers: {},
		favoriteToggle: true,
		reload: false,
		errorLogs: [],
		customersAutosuggestions: {},
		zoneHistoryLogs: {},
		[CUSTOMERS_COMPANIES_LOCATIONS]:
			JSON.parse(localStorage.getItem('customersCL')) || {},
		// only expanded status are stored
		customersAccordionStatuses: [],
		companiesAccordionStatuses: [],
		search: ''
	},
	mutations: {
		[SET_CUSTOMERS](state, data) {
			state.customers = data;
		},
		[CLEAR_CUSTOMERS](state) {
			state.customers = {};
		},
		[UPDATE_CUSTOMER](state, value) {
			const idx = state.customers.items.findIndex(
				item => item.companyId === value.companyId
			);
			if (idx > -1) {
				let customer = state.customers.items[idx];
				customer.favorite = value.favorite;
				customer.favoriteClicked = value.favoriteClicked;
			}
		},
		SetReloadCustomers(state, value) {
			state.reload = value;
		},
		SetFavoriteToggle(state, value) {
			state.favoriteToggle = value;
		},
		[SET_ERROR_LOGS](state, value) {
			state.errorLogs = value;
		},
		[ADD_CUSTOMERS_COMPANIES_LOCATIONS](state, { parameters, value }) {
			const key = generateKey(parameters);
			state.customersCL = { ...state.customersCL, [key]: value };
		},
		[SET_CUSTOMERS_AUTOSUGGESTIONS](state, value) {
			state.customersAutosuggestions = value;
		},
		[CLEAR_CUSTOMERS_AUTOSUGGESTIONS](state) {
			state.customersAutosuggestions = {};
		},
		[UPDATE_ACCORDION_STATUSES](state, { id, status, name }) {
			if (status) {
				state[name].push(id);
			} else {
				const index = state[name].findIndex(status => status === id);
				state[name].splice(index, 1);
			}
		},
		[CLEAR_ACCORDION_STATUSES](state) {
			state.customersAccordionStatuses.splice(
				0,
				state.customersAccordionStatuses.length
			);
			state.companiesAccordionStatuses.splice(
				0,
				state.companiesAccordionStatuses.length
			);
		},
		[UPDATE_CUSTOMERS_ZONE](state, zoneUpdates) {
			for (let i = 0; i < zoneUpdates.length; i++) {
				const cxUpdate = zoneUpdates[i];

				const cxIndex = state.customers.items.findIndex(
					cx => cx.id === cxUpdate.id
				);

				if (cxIndex !== -1) {
					state.customers.items[cxIndex] = {
						...state.customers.items[cxIndex],
						environmentId: cxUpdate.NewZoneId,
						environmentName: cxUpdate.NewZoneName
					};
				}
			}
		},
		[SET_ZONE_HISTORY_LOGS](state, obj) {
			state.zoneHistoryLogs = obj;
		},
		SetSearch(state, val) {
			state.search = val;
		}
	},
	actions: {
		async loadCustomerAutosuggestions(
			{ commit, dispatch, state },
			parameters
		) {
			return new Promise((resolve, reject) => {
				api.get('/customers/autosuggest', { params: parameters })
					.then(res => {
						if (state.search === parameters.search) {
							commit(SET_CUSTOMERS_AUTOSUGGESTIONS, res);
						}
						resolve();
					})
					.catch(error => {
						dispatch(
							TOAST_MESSAGES_PUSH,
							{
								statusCode: 400,
								message: error
							},
							{
								root: true
							}
						);
						reject();
					});
			});
		},
		// DEV NOTE: to remove, only to fetch data from db.json
		async loadCustomersCompaniesLocations(
			{ state, commit, dispatch },
			parameters
		) {
			const key = generateKey(parameters);
			if (!state.customersCL[key]) {
				await api
					.get('/customers', { params: parameters })
					.then(value => {
						commit(ADD_CUSTOMERS_COMPANIES_LOCATIONS, {
							parameters,
							value
						});
					})
					.catch(error => {
						dispatch(
							TOAST_MESSAGES_PUSH,
							{ statusCode: 400, message: error },
							{ root: true }
						);
					});
			}
			commit('SetReloadCustomers', false);
		},
		async loadCustomers({ state, commit, dispatch }, params) {
			const valuesToRemove = [undefined, '', 'all'];

			params = _.omitBy(params, value => valuesToRemove.includes(value));

			if (params.page === 1) {
				commit(CLEAR_CUSTOMERS);
			}

			return new Promise((resolve, reject) => {
				api.get('/customers/v2', { params })
					.then(res => {
						if (_.isEmpty(state.customers)) {
							commit(SET_CUSTOMERS, res);
						} else {
							let currentStore = _.cloneDeep(state.customers);
							let customersPayload = mergePayloadObjects(
								currentStore,
								res
							);
							commit(SET_CUSTOMERS, customersPayload);
						}
						commit('SetReloadCustomers', false);
						resolve();
					})
					.catch(error => {
						dispatch(
							TOAST_MESSAGES_PUSH,
							{
								statusCode: 400,
								message: error
							},
							{
								root: true
							}
						);
						reject();
					});
			});
		},
		updateCustomer({ commit }, customer) {
			commit(UPDATE_CUSTOMER, customer);
		},
		updateFavoriteToggle({ commit }, value) {
			commit('SetFavoriteToggle', value);
		},
		// error logs
		async getErrorLogs({ commit, dispatch }, customerId) {
			commit(SET_ERROR_LOGS, []);

			return new Promise((resolve, reject) => {
				api.get(`/errors/accessweb?CompanyId=${customerId}`)
					.then(resp => {
						commit(SET_ERROR_LOGS, resp.items);
						resolve();
					})
					.catch(() => {
						dispatch(
							TOAST_MESSAGES_PUSH,
							{
								statusCode: 400,
								message: 'error'
							},
							{
								root: true
							}
						);
						reject();
					});
			});
		},
		async moveToZone({ commit, dispatch }, ctxs) {
			return new Promise((resolve, reject) => {
				api.put('/customers/movetozone', ctxs)
					.then(res => {
						commit(UPDATE_CUSTOMERS_ZONE, res);
						resolve(res);
					})
					.catch(error => {
						dispatch(
							TOAST_MESSAGES_PUSH,
							{
								statusCode: 400,
								message: error
							},
							{
								root: true
							}
						);
						reject();
					});
			});
		},
		async [SET_ZONE_HISTORY_LOGS]({ dispatch, commit }, parameters) {
			await api
				.post(`/versionhistory`, parameters)
				.then(response => {
					commit(SET_ZONE_HISTORY_LOGS, response);
				})
				.catch(error => {
					if (error) {
						messageObj.message = error;
					}
					dispatch(TOAST_MESSAGES_PUSH, messageObj, {
						root: true
					});
				});
		}
	},
	getters: {
		customers: state => state.customers,
		[CUSTOMERS_COMPANIES_LOCATIONS]: state =>
			state.CUSTOMERS_COMPANIES_LOCATIONS,
		customerById: state => id => {
			if (!state.customers.items) {
				return null;
			}
			return state.customers.items.find(customer => customer.id === id);
		},
		favoriteToggle: state => state.favoriteToggle,
		reload: state => state.reload,
		customersCompaniesLocationByParams: state => params => {
			const key = generateKey(params);
			let result = state.customersCL[key];
			if (!result) {
				result = JSON.parse(localStorage.getItem(key));
			}
			return result || [];
		},
		zoneHistoryLogs: state => state.zoneHistoryLogs
	}
};

export { generateKey as GenerateKey };
